import { graphql } from "gatsby"
import React from "react"
import GeneralLayout from "../layouts/GeneralLayout"
import "../styles.css"

const Skills = props => {
  let lng = props.data.allContentfulLanguages.edges
  let ft = props.data.allContentfulFrontend.edges
  let bt = props.data.allContentfulBackend.edges
  let ts = props.data.allContentfulToolset.edges
  let env = props.data.allContentfulEnvironment.edges

  return (
    <GeneralLayout>
      <div className="aboutWrap">
        <div className="row">
          <div className="col-sm-1"></div>
          <div className="col-md-11">
            <h1>Skills and Toolset</h1>
            <div className="lineUnder"></div>
            <br />
            {/* Languages */}
            <h3>Languages</h3>
            <div className="stWrap">
              <div className="row">
                {lng.map(node => (
                  <div className="col-sm-2">
                    <img
                      className="stImg"
                      src={node.node.image.fluid.src}
                      alt="icon"
                    />
                    <br />
                    <span>{node.node.name}</span>
                  </div>
                ))}
              </div>
            </div>
            <br />
            <h3>Frontend Technologies</h3>
            <div className="stWrap">
              <div className="row">
                {ft.map(node => (
                  <div className="col-sm-2">
                    <img
                      className="stImg"
                      src={node.node.image.fluid.src}
                      alt="icon"
                    />
                    <br />
                    <span>{node.node.name}</span>
                  </div>
                ))}
              </div>
            </div>
            <br />
            <h3>Backened Technologies</h3>
            <div className="stWrap">
              <div className="row">
                {bt.map(node => (
                  <div className="col-sm-2">
                    <img
                      className="stImg"
                      src={node.node.image.fluid.src}
                      alt="icon"
                    />
                    <br />
                    <span>{node.node.name}</span>
                  </div>
                ))}
              </div>
            </div>
            <br />
            <h3>Toolset</h3>
            <div className="stWrap">
              <div className="row">
                {ts.map(node => (
                  <div className="col-sm-2">
                    <img
                      className="stImg"
                      src={node.node.image.fluid.src}
                      alt="icon"
                    />
                    <br />
                    <span>{node.node.name}</span>
                  </div>
                ))}
              </div>
            </div>
            <br />
            <h3>Environment</h3>
            <div className="stWrap">
              <div className="row">
                {env.map(node => (
                  <div className="col-sm-2">
                    <img
                      className="stImg"
                      src={node.node.image.fluid.src}
                      alt="icon"
                    />
                    <br />
                    <span>{node.node.name}</span>
                  </div>
                ))}
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </GeneralLayout>
  )
}

export default Skills

export const query = graphql`
  query {
    allContentfulLanguages {
      edges {
        node {
          name
          image {
            fluid {
              src
            }
          }
        }
      }
    }

    allContentfulFrontend {
      edges {
        node {
          name
          image {
            fluid {
              src
            }
          }
        }
      }
    }

    allContentfulBackend {
      edges {
        node {
          name
          image {
            fluid {
              src
            }
          }
        }
      }
    }

    allContentfulToolset {
      edges {
        node {
          name
          image {
            fluid {
              src
            }
          }
        }
      }
    }

    allContentfulEnvironment {
      edges {
        node {
          name
          image {
            fluid {
              src
            }
          }
        }
      }
    }
  }
`
